import { render, staticRenderFns } from "./Standfirst.vue?vue&type=template&id=7ee7cd38&"
import script from "./Standfirst.vue?vue&type=script&lang=js&"
export * from "./Standfirst.vue?vue&type=script&lang=js&"
import style0 from "./Standfirst.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseHeading: require('/opt/build/repo/storefront/components/atoms/Text/BaseHeading.vue').default})
